import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { Typography, Button } from '@tucar/pit-stop';
import { azulTucar } from '../../../../themes/variants/TucarColors';
import SelectionPeriod from '../components/selectionPeriod';

const SelectionStep = ({ onNext }) => {
  return (
    <Box>
      <Box
        sx={{
          position: 'absolute',
          top: '0px',
          left: '0px',
          width: '100vw',
          height: '100vh',
          background: 'linear-gradient(180deg, #EAFFFE 0%, rgba(205, 201, 241, 0.80) 100%)',
          backdropFilter: 'blur(2px)',
          paddingInline: '27px',
          zIndex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '30px 20px',
            paddingTop: '0px',
            width: 'calc(100vw - 50px)',
            gap: '10px',
          }}
        >
          <Typography
            align="center"
            color={azulTucar}
            style={{ fontSize: '18px', fontWeight: 600 }}
          >
            Organiza tu turno
          </Typography>
          <Typography
            color={azulTucar}
            align="center"
            style={{ fontSize: '14px', fontWeight: 400, lineHeight: '16px' }}
          >
            Una vez en la sección de solicitar cambio, agenda el día que deseas cambiar de turno con
            tu compañero. Recuerda que los cambios se realizan con al menos 1 día de anticipación.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            paddingBottom: '30px',
            width: '100%',
          }}
        >
          <Typography color={azulTucar} style={{ fontSize: '14px', fontWeight: 500 }}>
            Paso 4/6
          </Typography>
          <Button
            size="small"
            onClick={() => {
              onNext();
            }}
          >
            Siguiente
          </Button>
        </Box>

        <SelectionPeriod />
      </Box>
    </Box>
  );
};

SelectionStep.propTypes = {
  onNext: PropTypes.func,
};

SelectionStep.defaultProps = {
  onNext: () => {},
};

export default SelectionStep;
